import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { Test } from 'bookraw/shared/models/test.model';
import { Observable } from 'rxjs';
import { ItemResponse } from 'bookraw/shared/models/api/item.response';
import { environment } from 'env/environment';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { ListResponse } from 'bookraw/shared/models/api/list.response';

@Injectable()
export class TestsService extends ListService<Test> {

  url: string = '/api/admin/tests';

  reassignTests(testId: number, data: {
    userIds: number[],
    assignStartsAt: string,
    assignExpiresAt: string
  }): Observable<ItemResponse<Test>> {
    return this.http.post<ItemResponse<Test>>(environment.baseURL + this.url + '/' + testId + '/reassign', data);
  }

  unAssignTests(data: { userTestIds: number[] }): Observable<ItemResponse<Test>> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: data };
    return this.http.delete<ItemResponse<Test>>(environment.baseURL + this.url + '/assign', options);
  }

  getByUser(userId: string) {
    return this.http.get<ListResponse<Test>>(environment.baseURL + this.url + '/byUser/' + userId);
  }

  export(title: string, questionIds: string[]) {
    const params = new HttpParams({
      fromObject: { title: title, questionIds: questionIds.join(',') },
    });

    const headers = new HttpHeaders().set('Accept', 'application/pdf');
    return this.http.get(environment.baseURL + this.url + '/export' + this.queryParams.paramString, {
      headers, observe: 'response', params: params, responseType: 'blob'
    });
  }
}
